import React from 'react';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';

import { useAuth } from '../../../../../../hooks/Auth';
import { FiSend } from 'react-icons/fi';
import { FaQrcode, FaReceipt } from 'react-icons/fa';

interface ICreateModule {
  lineData: Record<string, any>;
}

export default function UpdateModule({

  lineData,

}: ICreateModule): JSX.Element {
  const { handleApiErrors } = useAuth();
  const { addToast } = useToast();



  const moduleUpdate = (): JSX.Element => (
    lineData.boleto_url ? <a href={lineData?.boleto_url} target="_BLANK"><button className="lineIcon" title="Visualizar boleto" type="button"  >
      <FaQrcode />
    </button> </a> : <></>
  );

  return moduleUpdate();
}
